export var ReminderKey = /*#__PURE__*/function (ReminderKey) {
  /**
   * @description
   * Notification that the user is now in their fertile/red days (for Prevent users)
   */
  ReminderKey["firstRedDay"] = "firstRedDay";
  /**
   * @description
   * Notification that the user is now in their not fertile/green days
   */
  ReminderKey["firstGreenDay"] = "firstGreenDay";
  /**
   * @description
   * Reminder to start taking LH tests
   */
  ReminderKey["checkLH"] = "checkLH";
  /**
   * @description
   * Reminder to take a pregnancy test for a Plan user
   */
  ReminderKey["startTesting"] = "startTesting";
  /**
   * @description
   * Reminder that PMS is approaching
   */
  ReminderKey["pms"] = "pms";
  /**
   * @description
   * Reminder that period is approaching
   */
  ReminderKey["period"] = "period";
  /**
   * @description
   * Reminder to perform a breast exam
   */
  ReminderKey["breastSelfCheck"] = "breastSelfCheck";
  /**
   * @description
   * Notification that the user is now in their fertile/red days (for Plan users)
   */
  ReminderKey["fertileDays"] = "fertileDays";
  /**
   * @description
   * Setting that includes fertility status in the push notification (for Apple Watch users only)
   */
  ReminderKey["fertilityStatus"] = "fertilityStatus";
  /**
   * @description
   * Notification that a Follow user entered a new pregnancy week
   */
  ReminderKey["newPregWeek"] = "newPregWeek";
  /**
   * @description
   * Notification that a Follow user entered a new pregnancy trimester
   */
  ReminderKey["newTrimester"] = "newTrimester";
  /**
   * @description
   * If the user has any local measuring reminders enabled
   */
  ReminderKey["localMeasuringReminder"] = "localMeasuringReminder";
  /**
   * @description
   * If the user has not saved any temperatures in the last 5 days using wearables (e.g., Oura or Apple Watch)
   */
  ReminderKey["missingWearableTemperature"] = "missingWearableTemperature";
  /**
   * @description
   * Notification that users device needs charging
   */
  ReminderKey["batteryStatus"] = "batteryStatus";
  return ReminderKey;
}(ReminderKey || {});